<template>
    <iframe id="frame" src="" />
</template>

<script>
export default {
    props: ["scene"],
    watch: {
        scene: function (newVal) {
            if (!newVal.id) {
                document
                    .getElementById("frame")
                    .contentWindow.switchScene(newVal);
            }
        },
    },
    mounted() {
        setTimeout(() => {
            document.getElementById("frame").src = "app/index.html";
        }, 1000);
    },
};
</script>

<style scoped>
#frame {
    width: 100%;
    height: 100%;
    border: none;
}

</style>